import { get } from "lodash";

const getters = {
  token: (state) => state.token,
  user: (state) => state.adminUser,
  isSupervisor: (state) => {
    let supervisor_roles = [
      /lead/,
      /admin/,
      /rma_lead/,
      /rsa_lead/,
      /developer/,
    ];

    // Check if adminUser and role exist before testing
    if (!state.adminUser || !state.adminUser.role) {
      return false;
    }

    const isMatch = supervisor_roles.some((rx) =>
      rx.test(state.adminUser.role.toLowerCase())
    );
    return Boolean(isMatch);
  },
  isAdmin: (state) => {
    if (state.adminUser) {
      return Boolean(state.adminUser.role.toLowerCase().match(/admin/));
    } else {
      return false;
    }
  },
  isUser: (state) => {
    return (
      state.adminUser &&
      Boolean(state.adminUser.role.toLowerCase().match(/user/))
    );
  },
  isNewLeftNav: (state) => {
    return get(state, "adminUser.acl.NewUI.leftNav", false);
  },
};

export default getters;
